import { Dispatch } from "redux";

import { isRequestActive, loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";
import { ThunkAction,ThunkDispatch } from "redux-thunk";
import { toast } from "@teamprevent/common/toasts";

import { ApplicationState } from "../../applicationState";

import * as actions from "./actiontypes";
import * as models from "./model";
import AdminUserApi from "./adminUserApi";
import { LOAD_ADMIN_USERS } from "./actiontypes";

import { push } from "redux-little-router";

export type AdminUserAction =
      ({ type: typeof actions.LOAD_ADMINUSERS_SUCCESS } & Payload<models.AdminUserDetailModel[]>)
    | ({ type: typeof actions.CREATE_ADMINUSER_SUCCESS } & Payload<models.AdminUserDetailModel>)
    | ({ type: typeof actions.LOAD_ADMINUSER_DETAIL_SUCCESS } & Payload<models.AdminUserDetailModel>)
    | ({ type: typeof actions.SAVE_ADMINUSER_SUCCESS } & Payload<models.AdminUserDetailModel>)
    | ({ type: typeof actions.DELETE_ADMINUSER_SUCCESS } & Payload<any>);

export const loadAdminUsersSuccess = (payload: models.AdminUserDetailModel[]): AdminUserAction => ({
    payload,
    type: actions.LOAD_ADMINUSERS_SUCCESS
});

export const createAdminUserSuccess = (payload: models.AdminUserDetailModel): AdminUserAction => ({
    payload,
    type: actions.CREATE_ADMINUSER_SUCCESS
});

export const saveAdminUserSuccess = (payload: models.AdminUserDetailModel): AdminUserAction => ({
    payload,
    type: actions.SAVE_ADMINUSER_SUCCESS
});

export const deleteAdminUserSuccess = (id: any): AdminUserAction => ({
    payload: id,
    type: actions.DELETE_ADMINUSER_SUCCESS
});

export function createAdminUser(adminUser: models.AdminUserCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_ADMINUSER, AdminUserApi.create(adminUser));
        dispatch(createAdminUserSuccess(result));
        dispatch(push(`${path}/${result.id}`, {}));
    };
}

export function saveAdminUser(adminUser: models.AdminUserEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_ADMINUSER, AdminUserApi.save(adminUser));

        dispatch(saveAdminUserSuccess(result));
        if (path !== undefined) {
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function deleteAdminUser(id: any, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, "loadAdminUserDetail", AdminUserApi.detail(id));
        dispatch(loadAdminUserDetailSuccess(result));

        if (result.hasAssignedTasks) {
            toast.error("The user has actionable tasks and cannot be deleted.");
            return;
        }

        await loadAndTrack(dispatch, "deleteAdminUser", AdminUserApi.delete(id));
        dispatch(deleteAdminUserSuccess(id));
        dispatch(push(`${path}`, {}));
    };
}

export function loadAdminUsers(finished: boolean = false): ThunkAction<Promise<void>, ApplicationState, undefined, any> {
    return async (dispatch: ThunkDispatch<models.AppState, undefined, any>, getState: () => ApplicationState) => {
        const isRequestInProgress = isRequestActive(getState(), LOAD_ADMIN_USERS);
        if (isRequestInProgress) { return; }

        const result = await loadAndTrack(dispatch, LOAD_ADMIN_USERS, AdminUserApi.getAll(finished));
        dispatch(loadAdminUsersSuccess(result));
    };
}

export const loadAdminUserDetailSuccess = (adminUser: models.AdminUserDetailModel) => ({
    payload: adminUser,
    type: actions.LOAD_ADMINUSER_DETAIL_SUCCESS
});

export function loadAdminUserDetail({ adminUserId }: { adminUserId: string}) {
    return async  (dispatch: Dispatch, getState: () => models.AppState) => {
        const adminUser = getState().adminUsers.filter(c => c.id === adminUserId)[0];

        if (adminUser === undefined
            || adminUser.detailUpdated === undefined
            || adminUser.detailUpdated.isBefore(adminUser.listUpdated)) {

            const action = adminUser === undefined ? createAdminUserSuccess : loadAdminUserDetailSuccess;

            const result = await loadAndTrack(dispatch, "loadAdminUserDetail", AdminUserApi.detail(adminUserId));
            dispatch(action(result));
        }
    };
}
